<!-- Personal Information Form -->
<form [formGroup]="userProfForm" (ngSubmit)="onSubmit()" *ngIf="userProfForm">
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">First Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="firstName">
    </div>
    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">Last Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="lastName">
    </div>
    <div class="col-12">
      <label class="form-label fw-semibold">Email Address <span class="text-danger">*</span></label>
      <input type="email" class="form-control" formControlName="email">
    </div>
    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">Phone Number</label>
      <input type="tel" class="form-control" formControlName="phoneNumber" placeholder="Enter phone number (optional)">
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">Country <span class="text-danger">*</span></label>
      <select class="form-select" formControlName="countryId">
        <option value="">{{getCountryPlaceholder()}}</option>
        <option *ngFor="let country of countries" [value]="country.id">
          {{country.name}}
        </option>
      </select>
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">State/Province <span class="text-danger">*</span></label>
      <!-- Show dropdown for US -->
      <select *ngIf="isUSSelected" class="form-select" formControlName="state">
        <option value="">{{getStatePlaceholder()}}</option>
        <option *ngFor="let state of states" [value]="state.id">
          {{state.name}}
        </option>
      </select>
      <!-- Show text input for other countries -->
      <input *ngIf="!isUSSelected" 
             type="text" 
             class="form-control" 
             formControlName="state" 
             [placeholder]="getStatePlaceholder()">
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">City <span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="city" placeholder="Enter city">
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">Address</label>
      <input type="text" class="form-control" formControlName="address" placeholder="Enter address">
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">Zip Code</label>
      <input type="text" class="form-control" formControlName="zipCode" placeholder="Enter zip code">
    </div>

    <div class="col-12" *ngIf="editMode">
      <hr>
      <button type="submit" class="btn btn-primary me-2">
        <i class="fa fa-save me-1"></i>
        Save Changes
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
        <i class="fa fa-times me-1"></i>
        Cancel
      </button>
    </div>
  </div>
</form>